/**
 * AgentsSwiper
 * 
 * @Author: Focci
 * @Date: 2024-10-08 17:33:12
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-08 17:33:12
 */

// import PropTypes from 'prop-types'
import { map } from 'lodash-es'
import { useMemo } from 'react'
import PhoneButton from '@comp/page/property/agent-card/PhoneButton'
import Carousel from '@comp/swiper/Carousel'
import clsx from 'clsx'
import Image from 'next/image'

function AgentsSwiperItem({ data }) {
  const avatars = useMemo(() => [
    ...data.avatars.filter((item) => item === data.avatar),
    ...data.avatars.filter((item) => item !== data.avatar)
  ], [data.avatar, data.avatars])
  
  return (
    <div className={clsx(['flex items-end gap-4', avatars.length > 1 ? 'px-9' : 'px-4'])}>
      <div className="flex-auto">
        <div className="flex items-start">
          {avatars.map((avatar, idx) => (
            <Image 
              alt={data.name}
              src={avatar || ''}
              width={idx === 0 ? 120 : 70}
              height={idx === 0 ? 120 : 70}
              className={clsx([
                'object-cover rounded-full object-top bg-cf0 relative border',
                idx === 0 ? 'w-12 h-12 z-1' : 'w-9 h-9 -mx-2 mt-1 blur-[1px]'
              ])}
            />
          ))}
        </div>
        <div className="mt-2 text-f.8 font-medium">
          {data.name}
        </div>
      </div>
      <div>
        <PhoneButton 
          phone={data.phone}
          agentId={data.id}
          trackParams={{ agencyOfficeId: data.officeId }}
        />
      </div>
    </div>
  )
}

export default function AgentsSwiper({ agents }) {
  const options = useMemo(() => {
    const avatars = map(agents, 'avatar')
    return map(agents, (agent) => ({ ...agent, avatars }))
  }, [agents])
  
  return (
    <div className="-mt-4">
      <Carousel
        data={options}
        SlideRender={AgentsSwiperItem}
        showPagination={false}
        leftNavigationWrapperClassName={clsx(['left-2'])}
        rightNavigationWrapperClassName={clsx(['right-2'])}
        NavigationProps={{ className: 'shadow-md w-5 h-5 bg-black/50 text-white rounded-full' }}
      />
    </div>
  )
}

// AgentsSwiper.propTypes = {
//   className: PropTypes.string,
// }
